import { config } from "@fortawesome/fontawesome-svg-core";

// Prevent FontAwesome from dynamically injecting CSS
// We import the CSS manually in index.css BEFORE Tailwind so utilities can override it
config.autoAddCss = false;
